import {Button, Divider, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {AuthRequest} from 'domain/usecases';
import {StyledCard} from 'presentation/components/StyledCard';
import {AuthorizationsEnum, DateFormatEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import IconNamesType from 'presentation/icons/IconNamesType';
import {translations} from 'presentation/translations-new';
import {formatDateString} from 'presentation/utils';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {TagChip} from 'presentation/components';
import {Status, cardStyleByStatus} from '../../constants';

import {AuthorizationCardContainer} from './styles';
import {NotificationStatus} from '../AuthorizationCardComponents';

const {showDetails} = translations['pt-br'].commons;
const {authorizationCard} = translations['pt-br'].privateFlow.requestAuthorizations;

export function RequestCard(authRequest: AuthRequest) {
	const theme = useTheme();
	const navigate = useNavigate();
	const {borderColor, chipText, chipVariant, chipTextColor, chipBackgroundColor} =
		cardStyleByStatus(theme, authRequest?.dsSituacao as Status);

	function handleNavigateDetail() {
		const path = AuthorizationsEnum.REQUEST_DETAIL;
		const nuControle = authRequest?.nuControle.toString() || '';
		navigate(path.replace(':id', nuControle), {state: {nuControle}});
	}

	const statusList = [
		{
			iconName: 'event-filled' as IconNamesType,
			primaryText: formatDateString(
				authRequest?.dtAutorizacao,
				DateFormatEnum.DATE_FORMAT_7,
				DateFormatEnum.DATE_FORMAT_8,
			),
			secondaryText: authorizationCard.requestedAt,
			flexDirection: 'column-reverse',
		},
		{
			iconName: 'assignment-filled' as IconNamesType,
			primaryText: authRequest?.nuProtocolo,
			secondaryText: authorizationCard.protocol,
			flexDirection: 'column-reverse',
		},
	];

	return (
		<AuthorizationCardContainer $borderColor={borderColor}>
			<Stack gap={1}>
				<Stack justifyContent="space-between" alignItems="center" direction="row" gap={2}>
					<Typography variant="h6" fontWeight={400} color="primary">
						{authorizationCard.request} <b>{authRequest?.nuControle}</b>
					</Typography>
					<NotificationStatus
						isNotificationsEnabled={authRequest.qtdNovasMsgs > 0}
						messageQuantity={authRequest?.qtdNovasMsgs}
					/>
				</Stack>

				<Stack direction="row" alignItems="center" justifyContent="space-between">
					<TagChip
							label={chipText}
							color={chipVariant}
							usePrimaryTextColor={false}
							sx={{
								color: chipTextColor,
								backgroundColor: chipBackgroundColor,
								'& .MuiChip-label': {color: chipTextColor},
							}}
						/>
					<Button
						variant="text"
						onClick={handleNavigateDetail}
						endIcon={<Icon name="arrow-right-filled" />}
						data-tag-id={AutoSolEnum.AS_CLICK_VER_DETALHES}>
						{showDetails}
					</Button>
				</Stack>

				<Divider />

				<StyledCard.Content sx={{flexDirection: 'column', gap: 2}} list={statusList} />
			</Stack>
		</AuthorizationCardContainer>
	);
}
